import { createSelector } from 'reselect';

import { getComponentProps } from '../form-designer/selectors/common.selectors';

export const getUpgradeModulesData = (state) => state.upgradeModules.modules;

export const getUpgradeModulesDataForTable = createSelector([getUpgradeModulesData], (modules) =>
  modules.map((module) => ({
    moduleId: module.Id,
    name: module.Module.Name,
    version: module.Module.Version,
    upgradeToVersion: module.Module.UpgradeToVersion,
    status: module.Status,
    modifiedDate: module.ModifiedDate,
    modifiedBy: module.ModifiedBy,
    upgrade: module.Status,
    logs: module.Log,
    customComponentsCount: module.CustomForms.length + module.CustomWorkflows.length,
  }))
);

export const getModuleWithInitialInProgressStatus = (state) =>
  state.upgradeModules.moduleWithInitialInProgressStatus;

export const isFetchingModuleSelector = (state) => state.upgradeModules.isFetchingModule;

export const getCurrentUpgradeModuleId = (state) => state.upgradeModules.currentUpgradeModuleId;

export const getFormConversionLogFile = (state) => state.upgradeModules.formConversionLogFile;

export const getCustomFormsAndWorkflows = createSelector(
  [getUpgradeModulesData, getComponentProps],
  (modules, { moduleId }) => {
    const foundModule = modules.find((module) => module.Id === moduleId);
    return {
      CustomForms: foundModule?.CustomForms?.map((c, index) => ({ ...c, index: index + 1 })),
      CustomWorkflows: foundModule?.CustomWorkflows?.map((c, index) => ({
        ...c,
        index: index + 1,
      })),
    };
  }
);
